import { MapBounds } from "../models/map.bounds";
import { MapLatLng } from "../models/map.latlng";
import { MapMarker } from "../models/map.marker";
import { MapPoint } from "../models/map.point";
import { CellCluster } from "./cell-cluster";
import { ItemCluster } from "./item-cluster";

// Para que se muestre la malla
var debug = false;

// Para definir la cantidad de marcadores que contendrá cada nivel de cluster
enum ClusterItems {
    I500 = 500,     // Cluster azul
    I2500 = 2500,   // Cluster amarillo
    I5000 = 5000,   // Cluster rojo
    I10000 = 10000, // Cluster magenta
    IX              // Cluster lila
}

export class MapClusterV2 {
    public id = 0;
    private map: any;
    public maxZoom = 18;
    private oldCells: CellCluster[] = [];
    private cells: CellCluster[] = [];
    private rows = 2;
    private columns = 4;
    public lastZoom = 0;
    public lastBounds?: MapBounds;
    public items: ItemCluster[] = [];
    private timerRefresh: any;
    private timerBounds: any;
    private timerAutoRefresh: any;
    private refreshCount = 0;

    constructor(map: any, maxZoom: number, id: number) {
        this.map = map;
        this.maxZoom = maxZoom < map.getMaxZoom() ? maxZoom : map.getMaxZoom();
        this.id = id;
        // Me subscribo a los cambios de zoom del mapa
        this.map.subscribeOnZoomChange(this, (thisObj: MapClusterV2, zoom: number) => {
            if (zoom < this.maxZoom) {
                this.items.forEach(item => {
                    item.setVisible(false);
                });
            }
        });
        // Me subscribo a los cambios de encuadre del mapa
        this.map.subscribeOnBoundsChange(this, (thisObj: MapClusterV2, bounds: MapBounds) => {
            if (this.timerBounds) {
                clearTimeout(this.timerBounds);
            }
            this.timerBounds = setTimeout(() => {
                this.refresh(false);
            }, 250);
        });
        // Me subscribo a los click sobre un marcador
        this.map.subscribeOnMarkerClick(this, (_thisObj: MapClusterV2, marker: MapMarker) => {
            // Compruebo que se trate de un marcador de cluster
            if (marker.dataModel.hasOwnProperty('numItems')) {
                // Compruebo si el marcador pertenece a éste cluster
                // for (let i = 0; i < this.cells.length; i++) {
                //     if (this.cells[i].marker && this.cells[i].marker.id === marker.id) {
                this.map.setCenter(marker.position);
                this.map.setZoom(this.map.zoom < this.maxZoom - 2 ? this.map.zoom + 2 : this.maxZoom);
                //         break;
                //     }
                // }
            }
        });
        // Creo el temporizador para refresco automático
        this.timerAutoRefresh = setInterval(() => {
            if (this.refreshCount > 0 && new Date().getTime() - this.refreshCount > 1) {
                this.refreshCount = 0;
                this.refresh(true);
            }
        }, 1000);
    }

    public removeCluster() {
        if (this.timerAutoRefresh) {
            clearInterval(this.timerAutoRefresh);
        }
        if (this.timerBounds) {
            clearTimeout(this.timerBounds);
        }
        if (this.timerRefresh) {
            clearTimeout(this.timerRefresh);
        }
        this.cells.forEach(cell => {
            this.map.removeMarker(cell.marker);
            if (cell.poligon) {
                this.map.removePolygon(cell.poligon);
            }
        });
        this.oldCells.forEach(cell => {
            this.map.removeMarker(cell.marker);
        });
        this.items.forEach(item => {
            item.remove();
        });
    }

    // Modifica el zoom máximo al que se rompe el cluster
    public setZoom(zoom: number) {
        this.maxZoom = zoom < this.map.getMaxZoom() ? zoom : this.map.getMaxZoom();
        this.shouldRefresh();
    }

    public addMarker(marker: MapMarker, refresh: boolean) {
        this.items.push(new ItemCluster(this.map, marker));
        if (refresh) {
            if (this.timerRefresh) {
                clearTimeout(this.timerRefresh);
            }
            this.timerRefresh = setTimeout(() => {
                this.refresh(false);
            }, 500);
        }
    }

    public removeMarker(marker: MapMarker, refresh: boolean) {
        for (let i = 0; i < this.items.length; i++) {
            if (this.items[i].marker === marker) {
                this.items.splice(i, 1);
                break;
            }
        }
        if (refresh) {
            if (this.timerRefresh) {
                clearTimeout(this.timerRefresh);
            }
            this.timerRefresh = setTimeout(() => {
                this.shouldRefresh();
            }, 500);
        }
    }

    public createCells() {
        const b = this.map.getBounds();
        const ra = (b.neCorner.lng - b.swCorner.lng) / (b.neCorner.lat - b.swCorner.lat);
        if(ra === Infinity){
          return;
        }
        switch (this.map.zoom) {
            case 1: case 2: case 3: case 4: case 5: case 6:
                this.rows = 3;
                break;
            case 7: case 8: case 9: case 10: case 11: case 12: case 13: case 14:
                this.rows = 4;
                break;
            default:
                this.rows = 5;
                break;
        }
        this.columns = Math.round((this.rows - 1) * ra);
        this.cells = [];
        for (let i = 0; i < this.rows * this.columns; i++) {
          this.cells.push(new CellCluster(this.map, new MapBounds(new MapLatLng(0, 0), new MapLatLng(0, 0)), debug));
        }
    }

    public refresh(reset: boolean) {
        const bounds = this.map.getBounds();
        if (this.map.zoom < this.maxZoom) {
            // Si ha cambiado el zoom creo de nuevo la malla
            if (this.lastZoom !== this.map.zoom || reset) {
                this.cells.forEach(cell => {
                    this.map.removeMarker(cell.marker);
                    if (debug && cell.poligon) {
                        this.map.removePolygon(cell.poligon);
                    }
                });
                this.oldCells.forEach(cell => {
                    this.map.removeMarker(cell.marker);
                });
                this.oldCells = [];
                this.items.forEach(item => {
                    item.intoCluster = false;
                    item.setVisible(false);
                });
                this.createCells();
            } else {
                if (this.lastBounds && (this.lastBounds.swCorner.lat !== bounds.swCorner.lat ||
                    this.lastBounds.swCorner.lng !== bounds.swCorner.lng)) {
                    this.cells.forEach(cell => {
                        this.oldCells.push(cell);
                        if (debug && cell.poligon) {
                            this.map.removePolygon(cell.poligon);
                        }
                    });
                    this.createCells();
                }
            }
            this.lastBounds = bounds;
            const ancho = (bounds.neCorner.lng - bounds.swCorner.lng) / this.columns;
            const alto = (bounds.neCorner.lat - bounds.swCorner.lat) / this.rows;
            // Creo las celdas
            for (let row = 0; row < this.rows; row++) {
                for (let col = 0; col < this.columns; col++) {
                    const i = row * this.columns + col;
                    const sw = new MapLatLng(bounds.swCorner.lat + (row * alto), bounds.swCorner.lng + (col * ancho));
                    const ne = new MapLatLng(bounds.swCorner.lat + (row * alto) + alto, bounds.swCorner.lng + (col * ancho) + ancho);
                    this.cells[i].setBounds(new MapBounds(sw, ne));
                }
            }
            // Veo que marcadores contiene cada celda
            this.items.forEach(item => {
                if (bounds.contains(new MapLatLng(item.lat, item.lng))) {
                    if (!item.intoCluster && item.marker?.visible) {
                        for (let i = 0; i < this.rows * this.columns; i++) {
                            if (this.cells[i].bounds.contains(new MapLatLng(item.lat, item.lng))) {
                                if (this.cells[i].numItems < 1) {
                                    this.cells[i].setMarkerPos(item.lat, item.lng);
                                    this.cells[i].oneItem = item;
                                }
                                this.cells[i].numItems++;
                                item.intoCluster = true;
                                break;
                            }
                        }
                    }
                }
            });
            // Pongo el texto con el número de marcadores a cada cluster
            this.cells.forEach(cell => {
                if (cell.numItems > 0) {
                    cell.marker.setLabel('' + cell.numItems);
                }
            });
            // Veo que clusters se solapan y los unifico
            for (let i = 0; i < this.rows * this.columns; i++) {
                if (this.cells[i].numItems > 0) {
                    const p1 = this.map.latLngToScreenPoint(this.cells[i].marker.position);
                    for (let j = i + 1; j < this.rows * this.columns; j++) {
                        if (this.cells[j].numItems > 0) {
                            // Calculo la distancia en pixels entre el centro de los dos cluster
                            const p2 = this.map.latLngToScreenPoint(this.cells[j].marker.position);
                            // En función del número de marcadores calculo la distancia
                            // mínima para que no se solapen los clusters
                            let minDist = 0;
                            if (this.cells[j].numItems <= ClusterItems.I500) {
                                minDist = 53;
                            } else {
                                if (this.cells[j].numItems <= ClusterItems.I2500) {
                                    minDist = 56;
                                } else {
                                    if (this.cells[j].numItems <= ClusterItems.I5000) {
                                        minDist = 66;
                                    } else {
                                        if (this.cells[j].numItems <= ClusterItems.I10000) {
                                            minDist = 78;
                                        } else {
                                            minDist = 90;
                                        }
                                    }
                                }
                            }
                            if (this.distance(p1, p2) < minDist) {
                                // Me quedo con la posición del cluster que tiene más marcadores
                                if (this.cells[j].numItems > this.cells[i].numItems) {
                                    this.cells[i].setMarkerPos(this.cells[j].marker.position.lat,
                                        this.cells[j].marker.position.lng);
                                }
                                this.cells[i].numItems += this.cells[j].numItems;
                                this.cells[i].marker.setLabel('' + this.cells[i].numItems);
                                // Vacio el cluster absorbido
                                this.cells[j].numItems = 0;
                            }
                        }
                    }
                }
            }
            this.cells.forEach(cell => {
                if (cell.numItems > 0) {
                    if (cell.numItems <= ClusterItems.I500) {
                        cell.marker.setIconEx('assets/images/cluster/m1.png', 52, 52,
                            new MapPoint(0, 0), new MapPoint(26, 26));
                        cell.marker.setZIndex(100);
                    } else {
                        if (cell.numItems <= ClusterItems.I2500) {
                            cell.marker.setIconEx('assets/images/cluster/m2.png', 56, 56,
                                new MapPoint(0, 0), new MapPoint(28, 28));
                            cell.marker.setZIndex(101);
                        } else {
                            if (cell.numItems <= ClusterItems.I5000) {
                                cell.marker.setIconEx('assets/images/cluster/m3.png', 66, 66,
                                    new MapPoint(0, 0), new MapPoint(33, 33));
                                cell.marker.setZIndex(102);
                            } else {
                                if (cell.numItems <= ClusterItems.I10000) {
                                    cell.marker.setIconEx('assets/images/cluster/m4.png', 78, 78,
                                        new MapPoint(0, 0), new MapPoint(39, 39));
                                    cell.marker.setZIndex(103);
                                } else {
                                    cell.marker.setIconEx('assets/images/cluster/m5.png', 90, 90,
                                        new MapPoint(0, 0), new MapPoint(45, 45));
                                    cell.marker.setZIndex(104);
                                }
                            }
                        }
                    }
                    if (cell.numItems > 1) {
                        cell.marker.setVisibleFromCluster(true);
                    } else {
                        cell.marker.setVisibleFromCluster(false);
                        cell.numItems = 0;
                        // Si sólo hay un marcador lo saco del cluster
                        cell.oneItem?.setVisible(true);
                    }
                } else {
                    cell.marker.setVisibleFromCluster(false);
                }
            });
        } else {
            this.cells.forEach(cell => {
                cell.marker.setVisibleFromCluster(false);
                cell.numItems = 0;
                if (debug && cell.poligon) {
                    this.map.removePolygon(cell.poligon);
                }
            });
            this.cells = [];
            this.oldCells.forEach(cell => {
                cell.marker.setVisibleFromCluster(false);
            });
            this.oldCells = [];
            this.items.forEach(item => {
                item.setVisible(bounds.contains(new MapLatLng(item.lat, item.lng)));
            });
        }
        this.lastZoom = this.map.zoom;
    }

    public refreshMarker(marker: MapMarker) {
        const bounds = this.map.getBounds();
        for (let i = 0; i < this.items.length; i++) {
            if (this.items[i].marker?.id === marker.id) {
                this.items[i].marker = marker;
                this.items[i].lat = marker.position.lat;
                this.items[i].lng = marker.position.lng;
                break;
            }
        }
        this.refresh(true);
    }

    shouldRefresh() {
        this.refreshCount = new Date().getTime();
    }

    distance(p1: any, p2: any) {
        return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
    }

}
